// -- other --
import React,{useState,useEffect} from "react";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../img";
import { all_routes } from "../../../feature-module/router/all_routes";
// -- biz9 --
import SubValue from "../../../feature-module/subValue";
import {Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Remote_Template,Portal_Table,Sub_Value_Type} from "biz9-portal-app";
import {Image,Storage,Field_Logic,App} from "../../../project";
import {UrlQuery} from "biz9-react-utility";
import {Data_Logic} from "biz9-data-app";
import {Image_Type} from "biz9-image";
import {Config} from "../../../constant";
import {Log,Str,Obj} from "biz9-utility";
const Footer = () => {
 /* -- DEFINE -- *
     * --- BUTTONZ ---
     * - 6 - ITEMS
     *   - link - string
     *   - icon - string - ex. fa-facebook
     * - 7 - ITEMS
     *   - title - string
     *   - thumb - image
     *   - value - string
     * - 8 - ITEMS
     *   - image - image
     * - 12 - ITEMS
     *   - title - string
     *   - link - string
     * - 14 - ITEMS
     *   - title - string
     *   - link - string
     * - 16 - ITEMS
     *   - title - string
     *   - link - string
     * - 10 - ITEMS
     *   - title - string
     *   - link - string
     *
 */

    const query = UrlQuery();
    const routes = all_routes;
    const location = useLocation();
    // -- template-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.TEMPLATE,0));
    const [template,setTemplate] = useState(Data_Logic.get(Portal_Table.TEMPLATE,0));
    const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);
    useEffect(() => {
        get_data();
    },[]);
    async function get_data() {
        let option = {get_cache:false,cache_limit:1};
        const [response,data] = await Portal_Remote_Template.get(App.get_url(Portal_Url.TEMPLATE_GET),Portal_Title.TEMPLATE_PRIMARY,option);
        Log.w('111_footer_data',data);
        bind_page(data);
    };
    async function bind_page(data) {
        // -- template --
        setTemplate(data[Portal_Type.TEMPLATE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.TEMPLATE,data[Portal_Type.TEMPLATE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
	async function bind_items(data) {
        // -- item--
        //setValTitleUrl(title_url);
        // -- items --
        //setBlogPosts(data[Portal_Type.BLOG_POSTS]);
	}
    //* ---- BIND-SUB-VALUES ----
    async function bind_sub_values(data_sub_group) {
        // -- sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
    //* ---- UPDATE-SUB-VALUE ----
     async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                }
            }));
        }else{
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                }
            }));
        }
    }

    return (
      <>
                  <footer className="footer">
            <div className="section-bg">
              <ImageWithBasePath
                src="/assets/img/bg/footer-bg-01.png"
                className="footer-bg-one"
                alt="img"
              />
              <ImageWithBasePath
                src="/assets/img/bg/footer-bg-02.png"
                className="footer-bg-two"
                alt="img"
              />
            </div>
            <div className="container">
              <div className="footer-top">
                <div className="row">
                  <div
                    className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                    data-aos="fade-up"
                    data-aos-delay={500}
                  >
                    <div className="footer-widget">
                      <Link to={"#"}>
                        <ImageWithBasePath
                          src="/assets/img/dark-logo.png"
                          alt="logo"
                        />
                      </Link>
                      <p>

                     {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,5):""}
                    {sub_value_group.sub_value_5.value}
                     </p>
                      <div className="social-links">
                        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,6):""}
                        <ul>
                        {sub_value_group.sub_value_6.items.map((item) => (
                          <li key={item.id}>
                            <Link to={item.link}>
                              <i className={'fa-brands ' + item.icon} />
                            </Link>
                          </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xl-2 col-lg-2 col-md-6 col-sm-6"
                    data-aos="fade-up"
                    data-aos-delay={600}
                  >
                    <div className="footer-widget">
                      <h3>
                    {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,11):""}
                    {sub_value_group.sub_value_11.value}
                      </h3>
                      <ul className="menu-items">
                        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,12):""}
                        {sub_value_group.sub_value_12.items.map((item) => (
                        <li key={item.id}>
                          <Link to={item.link}>{item.title}</Link>
                        </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                  <div
                    className="col-xl-2 col-lg-2 col-md-6 col-sm-6"
                    data-aos="fade-up"
                    data-aos-delay={800}
                  >
                    <div className="footer-widget">
                      <h3>
                     {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,13):""}
                    {sub_value_group.sub_value_13.value}
                     </h3>
                      <ul className="menu-items">
                        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,14):""}
                        {sub_value_group.sub_value_14.items.map((item) => (
                        <li key={item.id}>
                          <Link to={item.link}>{item.title}</Link>
                        </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                  <div
                    className="col-xl-4 col-lg-4 col-md-6 col-sm-6"
                    data-aos="fade-up"
                    data-aos-delay={700}
                  >
                    <div className="footer-widget">
                      <h3>
                     {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,15):""}
                    {sub_value_group.sub_value_15.value}
                      </h3>
                      <div className="row">
                        <div className="col-md-6">
                          <ul className="menu-items">
                        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,16):""}
                        {sub_value_group.sub_value_16.items.map((item) => (
                            <li key={item.id}>
                          <Link to={item.link}>{item.title}</Link>
                            </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-widget">
                  <div className="row align-items-center">
                    <div className="col-xl-9">
                      <ul className="location-list">
                        {sub_value_group.sub_value_7.items.map((item) => (
                        <li key={item.id}>
                          <span>
                            <ImageWithBasePath height={32} width={32} src={Image.get_url(item.thumb,Image_Type.ORIGINAL)} className="w-auto" alt="img" />
                          </span>
                          <div className="location-info">
                            <h6>{item.title}</h6>
                            <p>{item.value}</p>
                          </div>
                        </li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-xl-3 text-xl-end">

                    {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,7):""}
                      <div className="paypal-icons">

                    {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,8):""}
                    {sub_value_group.sub_value_8.items.map((item) => (
                        <Link to={item.id}  key={item.id} >
                          <ImageWithBasePath
                            src={Image.get_url(item.image,Image_Type.ORIGINAL)}
                            alt="icon"
                          />
                        </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="copy-right">
                      <p>
                    {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,9):""}
                    {sub_value_group.sub_value_9.value}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="footer-bottom-links">
                    {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,10):""}
                      <ul>
                    {sub_value_group.sub_value_10.items.map((item) => (
                        <li key={item.id}>i
                          <Link to={item.link}>{item.title}</Link>
                        </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
           <SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />
   </>
  );
};

export default Footer;
